export default {
  'You have worked today': 'You have worked today:  ',
  'Continue to work': 'Keep working',
  'have a bit of rest': 'Take a break',
  'Member registration': 'Member registration',
  'Total number of members': 'Total number of members',
  'Number of installed plug-ins': 'Number of installed plug-ins',
  'Membership growth': 'Membership growth',
  'Annex growth': 'Annex Growth',
  'New member': 'New Member',
  'Joined us': 'Joined us',
  'Member source': 'Member source',
  'Member last name': 'Member last name',
  Loading: 'Loading',
  Monday: 'Monday',
  Tuesday: 'Tuesday',
  Wednesday: 'Wednesday',
  Thursday: 'Thursday',
  Friday: 'Friday',
  Saturday: 'Saturday',
  Sunday: 'Sunday',
  Visits: 'Visits',
  'Registration volume': 'The number of registered users',
  month: 'month',
  picture: 'picture',
  file: 'file',
  table: 'table',
  'Compressed package': 'Compressed package',
  Baidu: 'Baidu',
  'Direct access': 'Direct access',
  'take a plane': 'Take a plane',
  'Take the high-speed railway': 'Take the high-speed rail',
  'full name': 'Full name',
  hour: 'Hour',
  minute: 'Minute',
  second: 'Second',
  day: 'Day',
  'Number of attachments Uploaded': 'Number of attachments upload'
}
